/* eslint-disable */

import React from 'react';
import cn from 'classnames';

import classes from './DropDownMenu.module.scss';

const DropDownMenu = ({ children = null, className }) => {
  return <div className={cn(classes.menuWrap, className)}>{children}</div>;
};

export default DropDownMenu;
